export const AllVideos = [
  // APPLE
  {
    _id: "609c6a6bcf8a604d0a91948d",
    title: "Spring Loaded - April 20",
    organiser: "Apple",
    description:
      "Watch the special Apple Event and learn about the new iMac, iPad Pro, and more.",
    isLatest: true,
    videoId: "JdBYVNuky1M",
    videoUrl: "https://www.youtube.com/watch?v=JdBYVNuky1M",
  },
  {
    _id: "609c6a6bcf8a604d0a91948e",
    title: "WWDC 2020",
    organiser: "Apple",
    description:
      "Apple WWDC 2020 kicked off with big announcements, exciting reveals, inspiration, and new opportunities to create the most innovative apps in the world.",
    isLatest: false,
    videoId: "GEZhD3J89ZE",
    videoUrl: "https://www.youtube.com/watch?v=GEZhD3J89ZE",
  },

  {
    _id: "609c6a6bcf8a604d0a91948f",
    title: "High Speed - October 13",
    organiser: "Apple",
    description:
      "Watch the special Apple Event and learn about the latest updates for HomePod mini, iPhone, and more.",
    isLatest: false,
    videoId: "KR0g-1hnQPA",
    videoUrl: "https://www.youtube.com/watch?v=KR0g-1hnQPA",
  },
  {
    _id: "609c6a6bcf8a604d0a919490",
    title: "September Event 2019 — Apple",
    organiser: "Apple",
    description:
      "Innovation takes the stage September 10, 2019. Check out the all-new iPhone 11 Pro, iPhone 11, Apple Watch Series 5, and iPad. And get the latest on Apple Arcade and Apple TV+.",
    isLatest: false,
    videoId: "-rAeqN-Q7x4",
    videoUrl: "https://www.youtube.com/watch?v=-rAeqN-Q7x4",
  },
  {
    _id: "609c6a6bcf8a604d0a919491",
    title: "September Event 2018 — Apple",
    organiser: "Apple",
    description:
      "Apple Special Event. September 12, 2018. Big news all around. Take a look at the all-new Apple Watch Series 4, iPhone XS and iPhone XS Max, and iPhone XR.",
    isLatest: false,
    videoId: "wFTmQ27S7OQ",
    videoUrl: "https://www.youtube.com/watch?v=wFTmQ27S7OQ",
  },
  {
    _id: "609c6a6bcf8a604d0a919492",
    organiser: "Apple",
    description:
      "Apple WWDC 2017. Take a look at our latest announcements. The new iPad Pro. iMac Pro. HomePod. iOS 11. macOS High Sierra. watchOS 4.",
    isLatest: false,
    videoId: "oaqHdULqet0",
    videoUrl: "https://www.youtube.com/watch?v=oaqHdULqet0",
  },

  //   GOOGLE

  {
    _id: "609c6a6bcf8a604d0a919493",
    title: "Google Keynote (Google I/O'19)",
    organiser: "Google",
    description:
      "Learn about the latest product and platform innovations at Google in a Keynote led by Sundar Pichai.",
    isLatest: true,
    videoId: "lyRPyRKHO8M",
    videoUrl: "https://www.youtube.com/watch?v=lyRPyRKHO8M",
  },

  {
    _id: "609c6a6bcf8a604d0a919494",
    title: "Google Keynote (Google I/O'18)",
    organiser: "Google",
    description:
      "Learn about the latest product and platform innovations at Google in a Keynote led by Sundar Pichai.",
    isLatest: false,
    videoId: "ogfYd705cRs",
    videoUrl: "https://www.youtube.com/watch?v=ogfYd705cRs",
  },

  {
    _id: "609c6a6bcf8a604d0a919495",
    title: "Google I/O 2017 - Keynote",
    organiser: "Google",
    description:
      "There's something new to love on October 4th. All features, functionality and other product specifications are subject to change without notice or obligation.",
    isLatest: false,
    videoId: "0YGoxbeSzLc",
    videoUrl: "https://www.youtube.com/watch?v=0YGoxbeSzLc",
  },

  {
    _id: "609c6a6bcf8a604d0a919496",
    title: "Google I/O 2016 - Keynote",
    organiser: "Google",
    description:
      "Watch the entire Google I/O Keynote here. Some highlights include the new messaging app Allo, the Video calling app Duo, the latest in Developer Platform innovation with Firebase, What's new in Android N, Android Wear 2.0 updates, and Android Instant Run.",
    isLatest: false,
    videoId: "862r3XS2YB0",
    videoUrl: "https://www.youtube.com/watch?v=862r3XS2YB0",
  },

  {
    _id: "609c6a6bcf8a604d0a919497",
    title: "Google I/O 2015 - Keynote",
    organiser: "Google",
    description:
      "Google I/O is the annual developers conference for the Mountain View-based search giant. In addition to updates on the next version of Android, Google could unveil additional news from its wide-ranging empire, including anything from search, self-driving cars, Android Wear, Chrome OS, Android TV or Nest smart home devices -- just to name a few.",
    isLatest: false,
    videoId: "WYXkWPB_fe8",
    videoUrl: "https://www.youtube.com/watch?v=WYXkWPB_fe8",
  },

  {
    _id: "609c6a6bcf8a604d0a919498",
    title: "Google I/O 2014 - Keynote",
    organiser: "Google",
    description:
      "Google I/O is the annual developers conference for the Mountain View-based search giant.",
    isLatest: false,
    videoId: "biSpvXBGpE0",
    videoUrl: "https://www.youtube.com/watch?v=biSpvXBGpE0",
  },

  //   SAMSUNG

  {
    _id: "609c6a6bcf8a604d0a919499",
    title: "Galaxy Unpacked January 2021",
    organiser: "Samsung",
    description:
      "It’s the moment we’ve all been waiting for. #SamsungUnpacked​ was LIVE on January 14, 2021.",
    isLatest: true,
    videoId: "TD_BZN0bn_U",
    videoUrl: "https://www.youtube.com/watch?v=TD_BZN0bn_U",
  },

  {
    _id: "609c6a6bcf8a604d0a91949a",
    title: "Samsung Galaxy Awesome Unpacked",
    organiser: "Samsung",
    description:
      "Ready for the next generation of awesome? #SamsungUnpacked​ #GalaxyA72​ #GalaxyA52​ #Awesome",
    isLatest: true,
    videoId: "17Tc8un6J40",
    videoUrl: "https://www.youtube.com/watch?v=17Tc8un6J40",
  },
  // {
  //   _id: "609c6a6bcf8a604d0a91949b",
  //   title: "Galaxy Note20: 2020",
  //   organiser: "Samsung",
  //   description: "Witness power like never before.",
  //   isLatest: true,
  //   videoId: "CmS5rlX9cDA",
  //   videoUrl: "https://www.youtube.com/watch?v=CmS5rlX9cDA",
  // },
  {
    _id: "609c6a6bcf8a604d0a91949c",
    title: "Galaxy Unpacked - 2019",
    organiser: "Samsung",
    description:
      "Watch the unveiling of the new Galaxy devices at Unpacked 2019.",
    isLatest: false,
    videoId: "USDvd7fhbd0",
    videoUrl: "https://www.youtube.com/watch?v=USDvd7fhbd0",
  },

  {
    _id: "609c6a6bcf8a604d0a91949d",
    title: "Samsung Galaxy Note 8 Presentation",
    organiser: "Samsung",
    description:
      "Samsung Galaxy Note 8 presentation in New York this August-2017.",
    isLatest: false,
    videoId: "0OSx0oQZzz4",
    videoUrl: "https://www.youtube.com/watch?v=0OSx0oQZzz4",
  },

  //MICROSOFT

  {
    _id: "609c6a6bcf8a604d0a91949e",
    title: "Microsoft Ignite 2021",
    organiser: "Microsoft",
    description:
      "Join us for our digital event experience on March 2-4, 2021. Microsoft Ignite is for IT pros, decision makers, implementors, architects, developers, and data professionals to explore the latest tools, receive deep technical training, and get questions answered by Microsoft experts.",
    isLatest: true,
    videoId: "Bha8qs4wB_8",
    videoUrl: "https://www.youtube.com/watch?v=Bha8qs4wB_8",
  },

  {
    _id: "609c6a6bcf8a604d0a91949f",
    title: "Vision Keynote | Microsoft Ignite 2019",
    organiser: "Microsoft",
    description:
      "Microsoft Ignite is for anyone who is motivated to be on the frontier of innovation and tech. Learn more about the event.",
    isLatest: false,
    videoId: "jnUiJi4hts4",
    videoUrl: "https://www.youtube.com/watch?v=jnUiJi4hts4",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a0",
    title: "#MicrosoftEvent​ Live",
    organiser: "Microsoft",
    description:
      "See what’s next from Microsoft Surface at the #MicrosoftEvent​ in New York City.",
    isLatest: false,
    videoId: "dmaioTs0NH8",
    videoUrl: "https://www.youtube.com/watch?v=dmaioTs0NH8",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a1",
    title: "Microsoft Build 2018 | Vision Keynote",
    organiser: "Microsoft",
    description:
      "CEO Satya Nadella takes the stage at Microsoft Build, our annual developer conference.",
    isLatest: false,
    videoId: "rd0Rd8w3FZ0",
    videoUrl: "https://www.youtube.com/watch?v=rd0Rd8w3FZ0",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a2",
    title: "Microsoft Build 2017",
    organiser: "Microsoft",
    description:
      "CEO Satya Nadella takes the stage at Microsoft Build, our annual developer conference.",
    isLatest: false,
    videoId: "nRkKoWx-_38",
    videoUrl: "https://www.youtube.com/watch?v=nRkKoWx-_38",
  },

  //   CES

  {
    _id: "609c6a6bcf8a604d0a9194a3",
    title: "The Best of CES 2020",
    organiser: "CES",
    description: "See The Best of CES 2020.",
    isLatest: true,
    videoId: "YvRP_Y1WDxw",
    videoUrl: "https://www.youtube.com/watch?v=YvRP_Y1WDxw",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a4",
    title: "The Best of CES 2019",
    organiser: "CES",
    description: "The Best of CES 2019: Only the cream of the crop",
    isLatest: false,
    videoId: "mHreov2zl1U",
    videoUrl: "https://www.youtube.com/watch?v=mHreov2zl1U",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a5",
    title: "The Best of CES 2018",
    organiser: "CES",
    description: "The Best of CES 2018: Only the cream of the crop",
    isLatest: false,
    videoId: "8UCOkXe6fyY",
    videoUrl: "https://www.youtube.com/watch?v=8UCOkXe6fyY",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a6",
    title: "The Best of CES 2017",
    organiser: "CES",
    description: "The Best of CES 2017: Only the cream of the crop",
    isLatest: false,
    videoId: "kjXizY4sJbY",
    videoUrl: "https://www.youtube.com/watch?v=kjXizY4sJbY",
  },

  {
    _id: "609c6a6bcf8a604d0a9194a7",
    title: "The Best of CES 2015",
    organiser: "CES",
    description: "The Best of CES 2015: Only the cream of the crop",
    isLatest: false,
    videoId: "jTGb3ubedgU",
    videoUrl: "https://www.youtube.com/watch?v=jTGb3ubedgU",
  },
];
